// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__MWGG3","col":"styles_col__3K2bb"};